<div class="toast-layer" aria-live="polite" aria-atomic="false">
  @for (toast of toasts(); track toast.id) {
    <app-banner
      [class.toast--dismissing]="toast.dismissing"
      [type]="toast.type"
      [title]="toast.title"
      [description]="toast.description"
      [dismissible]="true"
      (dismissed)="dismiss(toast.id)"
    />
  }
</div>
